import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { api } from "./services/api";
import { chatApi } from "./services/chatsApi";
import { settingsApi } from "./services/settingsApi";
import sipReducer from "./slices/sipSlice";
import chatReducer from "./slices/chatSlice";
import contactsReducer from "./slices/contactsSlice";

const appReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  sip: sipReducer,
  chat: chatReducer,
  contacts: contactsReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      api.middleware,
      chatApi.middleware,
      settingsApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
